import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EmergencyProvider } from "../../context/EmergencyContext";
import EmergencyPanel from "./EmergencyPanel";

const EmergencyPage = () => {
  const { t } = useTranslation();

  return (
    <EmergencyProvider>
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
          {t("nav.emergency", "Emergency")}
        </Typography>
        <EmergencyPanel />
      </Box>
    </EmergencyProvider>
  );
};

export default EmergencyPage;
